export const initialSteps = [
    {
        target: '[data-tour="upload-area"]',
        content: 'Drag & drop your inventory CSV file here to start importing',
        placement: 'top',
        disableBeacon: false,
        disableOverlay: true,
    },
];

export const importButtonStep = [
    {
        target: '[data-tour="import-button"]',
        content:
            'Once everything looks good, click “Import” to save this file into your inventory.',
        placement: 'top',
        disableBeacon: false,
        disableOverlay: true,
    },
];

export const headerDescriptions = {
    'Purchase id *': 'Choose the unique ID for each purchase from your CSV file.',
    'Reference id (Order No.)':
        'This field is used to store the Order ID and is required for AI Matching to work accurately. For Lysted users: use “external reference” which includes the order ID.',
    'Description (Event Name) *': 'Choose Event Name from your CSV file.',
    'Description 2 (Event Venue)': 'Choose Venue from your CSV file.',
    'Class 1 (Section, category) *': 'Choose Section from your CSV file.',
    'Class 2 (Row, sub-category) *': 'Choose Row from your CSV file.',
    'Class 3 (Seat, sub-detail) *': 'Choose Seat from your CSV file.',
    'Purchase Price *': 'Choose Purchase Price from your CSV file.',
    'Expiration date (Event date) *': 'Choose Event Date from your CSV file.',
    'Purchase date *': 'Choose Purchase Date from your CSV file.',
    'Purchaser email':
        'Required for Agent Matching; identifies who made the purchase. (Lysted users: use Internal Notes column.)',
};

// export const generateMappingSteps = (customHeaders) => {
//     return customHeaders.map((ch) => {
//         const slug = ch
//             .toLowerCase()
//             .replace(/[^a-z0-9]+/g, '-')
//             .replace(/(^-|-$)/g, '');

//         return {
//             target: `[data-tour="map-${slug}"]`,
//             content: tutorialContentMap[ch] || `Select your "${ch.replace(/\s*\*$/, '')}" column`,
//             placement: 'bottom',
//             disableBeacon: false,
//         };
//     });
// };
